/**
 * <toppik-logo-dust>
 * Renders the Toppik wordmark as an interactive chalk-dust particle field
 * (Three.js). Config comes from data-* attributes (set by the section). The
 * animation only runs while the element is on screen. Requires window.THREE.
 */
const TOPPIK_LOGO_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="80" height="40" viewBox="0 0 80 40" fill="none"><g fill="#111111"><path d="M77.1098 28.8227H76.4286V30.6536H76.1929V28.8314H75.5117V28.6222H77.1185V28.8314L77.1098 28.8227ZM79.7121 28.6047H79.4764L78.7341 29.7207L77.9831 28.6135H77.7473V30.6536H77.9743V29.0058L78.7253 30.0956H78.7341L79.4764 29.0058V30.6536H79.7121V28.6135V28.6047Z"/><path d="M3.7192 30.7061C3.63187 30.7061 3.57074 30.6364 3.57074 30.5579V30.061C3.57074 29.9825 3.63187 29.9128 3.7192 29.9128L5.08149 29.8692L5.06403 9.26759C4.94177 9.26759 4.81078 9.26759 4.66233 9.26759C3.78906 9.26759 2.58395 9.25016 2.05999 9.38965C1.61462 9.50299 1.5011 9.63376 1.31771 9.83429L1.25658 9.90403C0.924743 10.2615 0.802486 11.5344 0.78502 11.9964C0.78502 12.0749 0.715159 12.1447 0.636565 12.1447H0.156268C0.0689412 12.1447 0.0078125 12.0749 0.0078125 11.9964V8.5614C0.0078125 8.5614 0.0165452 8.48294 0.0514759 8.45678C0.0776739 8.43063 0.121337 8.41319 0.156268 8.41319C0.156268 8.41319 11.3079 8.40447 12.1986 8.39575C12.2859 8.39575 12.3471 8.4655 12.3471 8.54396C12.3645 9.59017 12.3645 11.9877 12.3645 11.9877C12.3645 12.0749 12.2947 12.1359 12.2161 12.1359H11.7445C11.6572 12.1359 11.5961 12.0662 11.5961 11.9877C11.5961 11.3687 11.5087 10.2876 11.3428 10.0348C11.1507 9.7471 10.9149 9.5553 10.3036 9.42452C9.79714 9.31118 8.49597 9.27631 7.38692 9.26759L7.40438 29.8692L8.74922 29.904C8.82781 29.904 8.89767 29.9738 8.89767 30.0522V30.5579C8.89767 30.6451 8.82781 30.7061 8.74922 30.7061H3.73666H3.7192Z"/><path d="M55.3125 30.6451C55.3125 30.6451 55.2339 30.6277 55.2077 30.6015C55.1815 30.5753 55.1641 30.5318 55.1641 30.4969V30.0087C55.1641 29.9302 55.2339 29.8604 55.3125 29.8604L56.6224 29.8081L56.605 9.15425H55.461C55.461 9.15425 55.3824 9.13681 55.3562 9.11066C55.33 9.0845 55.3125 9.04091 55.3125 9.00604V8.49165C55.3125 8.49165 55.33 8.41319 55.3562 8.38703C55.3824 8.36088 55.426 8.34344 55.461 8.34344C55.461 8.34344 57.7053 8.3696 58.7183 8.14292C58.7619 8.1342 58.8143 8.14292 58.8493 8.16907C58.8842 8.19523 58.9104 8.23882 58.9104 8.29113L58.9453 29.8081L60.2814 29.843C60.36 29.843 60.4299 29.9128 60.4299 29.9912V30.4882C60.4299 30.4882 60.4211 30.5666 60.3862 30.5928C60.36 30.6189 60.3163 30.6364 60.2814 30.6364H55.33L55.3125 30.6451Z"/><path d="M61.8982 30.6452C61.8109 30.6452 61.7498 30.5754 61.7498 30.497V30C61.7498 29.9216 61.8109 29.8518 61.8982 29.8431L63.278 29.7821L63.2518 9.17178L61.8633 9.12819C61.7847 9.12819 61.7148 9.05844 61.7148 8.97997V8.48303C61.7148 8.48303 61.7323 8.40456 61.7585 8.3784C61.7847 8.35225 61.8284 8.33481 61.8633 8.33481H66.8147C66.9021 8.33481 66.9632 8.39584 66.9632 8.48303V8.99741C66.9632 9.07588 66.9021 9.14562 66.8147 9.14562L65.435 9.19793V18.6312C65.4437 18.7359 65.435 19.102 65.4175 19.4072C65.6271 19.0933 65.9153 18.6487 66.0113 18.4917C66.0462 18.4307 70.5261 10.4359 70.692 10.0436C70.7968 9.79079 70.7182 9.35487 70.6134 9.24153C70.4999 9.12819 69.6965 9.05844 69.4258 9.05844C69.4258 9.05844 69.4171 9.05844 69.4083 9.05844C69.3647 9.05844 69.3297 9.041 69.3035 9.01485C69.2773 8.98869 69.2599 8.9451 69.2599 8.91023V8.40456C69.2599 8.40456 69.2773 8.32609 69.3035 8.29994C69.3297 8.27378 69.3734 8.25635 69.4083 8.25635H73.7572C73.8445 8.25635 73.9057 8.32609 73.9057 8.40456V8.91023C73.9057 8.91023 73.8882 8.98869 73.862 9.01485C73.8358 9.041 73.7921 9.06716 73.7485 9.05844C73.7485 9.05844 73.1634 9.04972 72.9014 9.09331C72.7005 9.13691 72.3949 9.30255 72.1766 9.63385C72.0631 9.81694 70.9278 11.9704 70.0196 13.7053C68.6049 16.3993 68.5351 16.5301 68.5089 16.565L68.4477 16.626C68.4477 16.626 68.4565 16.6522 68.4652 16.6696C68.5089 16.7481 71.9932 25.728 73.5301 29.7036L74.8139 29.7559C74.8924 29.7559 74.9623 29.8257 74.9623 29.9041V30.3924C74.9623 30.4795 74.8924 30.5406 74.8139 30.5406H69.6266C69.5393 30.5406 69.4782 30.4795 69.4782 30.3924V29.8954C69.4782 29.8169 69.5393 29.7472 69.6266 29.7472L70.9365 29.6949L67.0942 19.2502C67.0942 19.2502 67.0592 19.1456 67.033 19.0584C66.7623 19.4856 65.8803 20.7847 65.435 21.4211V29.7733L66.9021 29.8518C66.9806 29.8518 67.0505 29.9216 67.0505 30V30.4795C67.0505 30.5667 66.9806 30.6278 66.9021 30.6278H61.8982V30.6452Z"/><path d="M22.5212 9.41583C21.5693 8.45681 20.4341 7.97729 19.1591 7.97729C13.5615 7.97729 12.3214 16.1813 12.3127 19.3374C12.2952 22.5893 13.4654 31.0549 19.0368 31.0985H19.0805C20.4428 31.0985 21.6305 30.6015 22.626 29.6251C25.7173 26.5736 25.7697 20.0697 25.7697 19.7907C25.7697 17.3321 25.1148 11.9965 22.5299 9.40711L22.5212 9.41583ZM19.229 30.2441H19.1853C17.2816 30.2179 16.2162 29.1107 15.5176 26.4254C15.1246 24.9346 14.7578 21.1246 14.7753 19.4681V19.3548C14.8015 16.7742 14.8364 13.8448 15.8756 11.3862C16.5218 9.85175 17.7793 8.86657 19.0805 8.86657H19.098C20.4952 8.86657 21.6566 9.83431 22.1893 11.4472C23.1237 14.2458 23.1761 16.4864 23.2373 19.3199V19.4943C23.2897 21.5431 23.0888 23.6268 22.6434 25.8587C22.0584 28.8055 20.9406 30.2441 19.2202 30.2441H19.229Z"/><path d="M37.4715 10.1134C36.9475 9.34621 36.4061 8.83183 35.7249 8.45693C35.035 8.1082 34.3626 7.94255 33.7164 7.95999C31.4983 8.0123 30.4067 9.90419 29.8653 11.5956C29.9264 10.3314 29.9352 8.99747 29.9264 8.30872C29.9264 8.26513 29.9002 8.22154 29.8653 8.18666C29.8304 8.16051 29.778 8.15179 29.7343 8.16051C28.9134 8.37847 27.8306 8.36975 26.9661 8.36975H26.5556C26.5556 8.36975 26.477 8.38719 26.4508 8.41334C26.4246 8.4395 26.4072 8.48309 26.4072 8.51796V9.03235C26.4072 9.11953 26.477 9.18056 26.5644 9.18056H27.7957L27.8393 39.1544L26.5469 39.2242C26.4683 39.2242 26.3984 39.2939 26.3984 39.3811V39.8519C26.3984 39.9391 26.4683 40.0001 26.5556 40.0001H31.3848C31.3848 40.0001 31.4634 39.9739 31.4896 39.9478C31.5158 39.9216 31.5332 39.878 31.5332 39.8432V39.3811C31.5332 39.3026 31.4721 39.2329 31.3848 39.2329L30.1098 39.1544C30.0924 38.0036 30.005 30.2268 30.0312 27.899C30.0312 27.7856 30.0312 27.681 30.0312 27.5764C30.4853 29.0411 31.2887 30.5406 32.8868 30.9242C34.45 31.2991 35.8035 30.5493 36.5545 29.7211C39.1307 26.8963 39.6459 23.0428 39.8118 20.0088C40.0214 16.225 39.1569 12.5284 37.4889 10.1134H37.4715ZM37.1309 24.0716C36.6681 26.9748 35.952 28.7882 34.939 29.6078C34.4587 30.0001 33.8125 30.1483 33.2187 30.0175C32.7122 29.9042 31.9961 29.5467 31.4459 28.4482C30.7036 26.9399 30.267 25.4665 30.1098 23.9321C29.7081 20.4622 29.5073 15.4927 30.887 11.5432C31.0966 10.933 31.935 8.93645 33.6553 8.90157C33.6815 8.90157 33.6989 8.90157 33.7251 8.90157C34.8517 8.90157 35.8821 9.67751 36.3013 10.8545C37.0785 13.0428 37.323 15.1963 37.4453 17.7682C37.4889 18.701 37.3143 22.9208 37.1309 24.089V24.0716Z"/><path d="M51.8092 10.0871C51.2766 9.31116 50.7351 8.80549 50.0627 8.43932C49.3554 8.08187 48.6917 7.91622 48.0542 7.94237C45.8361 7.99468 44.7358 9.89529 44.2031 11.5779C44.2642 10.3225 44.2729 8.98858 44.2642 8.29111C44.2642 8.24752 44.238 8.20392 44.2031 8.16905C44.1682 8.13418 44.1158 8.13418 44.0721 8.1429C43.2512 8.36086 42.1684 8.35214 41.2864 8.35214H40.8847C40.8847 8.35214 40.8061 8.36957 40.7799 8.39573C40.7537 8.42188 40.7362 8.46548 40.7362 8.50035V9.01474C40.7362 9.10192 40.8061 9.16295 40.8934 9.16295H42.116L42.1596 39.1368L40.8672 39.2065C40.7886 39.2065 40.7188 39.2763 40.7188 39.3635V39.8343C40.7188 39.9214 40.7886 39.9825 40.8759 39.9825H45.7051C45.7051 39.9825 45.7837 39.9563 45.8099 39.9302C45.8361 39.904 45.8536 39.8604 45.8536 39.8255V39.3635C45.8536 39.285 45.7924 39.2153 45.7051 39.2153L44.4301 39.1368C44.4127 37.986 44.3253 30.2092 44.3515 27.8813C44.3515 27.768 44.3515 27.6634 44.3515 27.5588C44.8144 29.0235 45.6178 30.5317 47.1984 30.9066C48.7615 31.2815 50.1151 30.5317 50.8661 29.7035C53.4335 26.8787 53.9575 23.0252 54.1234 19.9912C54.333 16.2161 53.4684 12.5108 51.8005 10.0958L51.8092 10.0871ZM51.4687 24.0627C51.0058 26.9659 50.2898 28.7793 49.2768 29.5989C48.7965 29.9825 48.1503 30.1394 47.5564 30.0086C47.0499 29.8953 46.3339 29.5378 45.7924 28.4393C45.0502 26.931 44.6135 25.4576 44.4476 23.9232C44.0459 20.4533 43.8538 15.4751 45.2335 11.5344C45.4431 10.9241 46.2727 8.92755 48.0018 8.89268C48.028 8.89268 48.0542 8.89268 48.0717 8.89268C49.1982 8.89268 50.2199 9.66861 50.6391 10.8456C51.4163 13.0252 51.6608 15.1874 51.783 17.7593C51.8267 18.6398 51.6608 22.9119 51.4774 24.0801L51.4687 24.0627Z"/><path d="M57.1653 6.68703C56.9469 6.68703 56.8509 6.70446 56.7898 6.63472C56.7636 6.59984 56.7461 6.56497 56.7461 6.52138C57.0168 3.18223 57.2788 2.65913 59.7851 0.392345L60.2304 0.0348913C60.2916 -0.00870073 60.3701 -0.00870073 60.4313 0.0348913C60.4837 0.0872016 60.5011 0.165667 60.4575 0.235414C58.7895 2.7899 58.7371 4.47255 58.6935 5.82391C58.6935 6.07674 58.676 6.31214 58.6585 6.54753C58.6585 6.626 58.5887 6.68703 58.5101 6.68703C58.5101 6.68703 57.6368 6.68703 57.1653 6.68703Z"/></g></svg>`;

const EasingFunctions = {
  linear: (t) => t,
  easeIn: (t) => t * t,
  easeOut: (t) => 1 - Math.pow(1 - t, 2),
  easeInOut: (t) => (t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2),
  exponential: (t) => (t === 0 ? 0 : Math.pow(2, 10 * (t - 1))),
};

class ToppikLogoDust extends HTMLElement {
  connectedCallback() {
    if (this.dataset.booted) return;
    this.dataset.booted = '1';

    const d = this.dataset;
    this.config = {
      particleDensity: parseFloat(d.density) || 1,
      minParticleCount: parseInt(d.minParticles, 10) || 20000,
      maxParticleCount: parseInt(d.maxParticles, 10) || 150000,
      mouseSize: parseFloat(d.mouseSize) || 0.2,
      retractingSpeed: parseFloat(d.retractSpeed) || 1,
      retractingEase: d.ease || 'easeInOut',
      reassembleDelay: parseInt(d.reassembleDelay, 10) || 1200,
      particleSize: parseFloat(d.particleSize) || 1.2,
      opacity: parseFloat(d.opacity) || 0.75,
      color: d.color || '#ffffff',
    };

    this.whenThreeReady(() => this.init());
  }

  whenThreeReady(cb) {
    let done = false;
    const run = () => {
      if (!done && window.THREE) {
        done = true;
        cb();
      }
    };
    if (window.THREE) return run();

    // Load Three.js once, on demand (no parser-blocking script in the section).
    const SRC = 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js';
    if (!document.querySelector('script[data-three-loader]')) {
      const script = document.createElement('script');
      script.src = SRC;
      script.async = true;
      script.setAttribute('data-three-loader', '');
      document.head.appendChild(script);
    }
    let tries = 0;
    const timer = setInterval(() => {
      if (window.THREE) {
        clearInterval(timer);
        run();
      } else if (++tries > 300) {
        clearInterval(timer);
      }
    }, 50);
  }

  init() {
    const THREE = window.THREE;
    const CONFIG = this.config;
    const container = this;

    let scene, camera, renderer, particleSystem;
    let particlesData = [];
    let validPixelsNormalized = [];
    let activeParticleCount = 0;
    let animFrameId = null;
    let running = false;

    const mouse = { x: -9999, y: -9999, vx: 0, vy: 0, lastX: null, lastY: null };
    let lastInteractionTime = 0;

    const createChalkDustTexture = () => {
      const canvas = document.createElement('canvas');
      canvas.width = 16;
      canvas.height = 16;
      const ctx = canvas.getContext('2d');
      const gradient = ctx.createRadialGradient(8, 8, 0, 8, 8, 8);
      // Solid opaque core with a soft edge, so a dense field reads as a solid
      // white logo (rather than faint dust) while a scattered field still looks
      // like individual specks.
      gradient.addColorStop(0, 'rgba(255, 255, 255, 1)');
      gradient.addColorStop(0.6, 'rgba(255, 255, 255, 1)');
      gradient.addColorStop(0.85, 'rgba(255, 255, 255, 0.5)');
      gradient.addColorStop(1, 'rgba(255, 255, 255, 0)');
      ctx.fillStyle = gradient;
      ctx.fillRect(0, 0, 16, 16);
      return new THREE.CanvasTexture(canvas);
    };

    const calculateTargetPositions = (w) => {
      // The wordmark is 88% of the container, but never wider than 1200px — so
      // on a full-width canvas the logo stays capped while particles can scatter
      // into the space beyond it.
      const targetW = Math.min(w * 0.88, 1200);
      const targetH = targetW / 2;
      return { targetW, targetH };
    };

    const calculateDynamicParticleCount = (w, h) => {
      const target = Math.round(w * h * CONFIG.particleDensity);
      return Math.min(Math.max(target, CONFIG.minParticleCount), CONFIG.maxParticleCount);
    };

    const buildParticleGeometry = () => {
      if (particleSystem) {
        scene.remove(particleSystem);
        particleSystem.geometry.dispose();
        particleSystem.material.dispose();
      }
      const width = container.clientWidth;
      const height = container.clientHeight;
      const { targetW, targetH } = calculateTargetPositions(width, height);
      activeParticleCount = calculateDynamicParticleCount(width, height);

      const geometry = new THREE.BufferGeometry();
      const positions = new Float32Array(activeParticleCount * 3);
      particlesData = [];

      for (let i = 0; i < activeParticleCount; i++) {
        const target = validPixelsNormalized[Math.floor(Math.random() * validPixelsNormalized.length)];
        const ox = target.nx * targetW + (Math.random() - 0.5) * 0.8;
        const oy = target.ny * targetH + (Math.random() - 0.5) * 0.8;
        positions[i * 3] = ox;
        positions[i * 3 + 1] = oy;
        positions[i * 3 + 2] = 0;
        particlesData.push({
          nx: target.nx,
          ny: target.ny,
          ox,
          oy,
          x: ox,
          y: oy,
          vx: 0,
          vy: 0,
          drag: 0.8 + Math.random() * 0.14,
          springVariance: 0.8 + Math.random() * 0.4,
          sensitivity: 0.6 + Math.random() * 0.8,
          radiusNoise: 0.75 + Math.random() * 0.5,
        });
      }

      geometry.setAttribute('position', new THREE.BufferAttribute(positions, 3));
      const material = new THREE.PointsMaterial({
        size: CONFIG.particleSize,
        map: createChalkDustTexture(),
        color: new THREE.Color(CONFIG.color),
        transparent: true,
        depthWrite: false,
        blending: THREE.AdditiveBlending,
        opacity: 1,
      });
      particleSystem = new THREE.Points(geometry, material);
      scene.add(particleSystem);
    };

    const sampleSVGPoints = () => {
      const blob = new Blob([TOPPIK_LOGO_SVG], { type: 'image/svg+xml;charset=utf-8' });
      const url = URL.createObjectURL(blob);
      const img = new Image();
      img.onload = () => {
        const sampleW = 1000;
        const scale = sampleW / img.width;
        const sampleH = Math.round(img.height * scale);
        const offCanvas = document.createElement('canvas');
        const ctx = offCanvas.getContext('2d');
        offCanvas.width = sampleW;
        offCanvas.height = sampleH;
        ctx.drawImage(img, 0, 0, sampleW, sampleH);
        const imgData = ctx.getImageData(0, 0, sampleW, sampleH).data;
        URL.revokeObjectURL(url);
        validPixelsNormalized = [];
        for (let y = 0; y < sampleH; y++) {
          for (let x = 0; x < sampleW; x++) {
            if (imgData[(y * sampleW + x) * 4 + 3] > 30) {
              validPixelsNormalized.push({ nx: x / sampleW - 0.5, ny: -(y / sampleH - 0.5) });
            }
          }
        }
        buildParticleGeometry();
        startWhenVisible();
      };
      img.src = url;
    };

    const onWindowResize = () => {
      if (!particleSystem) return;
      const width = container.clientWidth;
      const height = container.clientHeight;
      camera.left = -width / 2;
      camera.right = width / 2;
      camera.top = height / 2;
      camera.bottom = -height / 2;
      camera.updateProjectionMatrix();
      renderer.setSize(width, height);
      renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
      const newCount = calculateDynamicParticleCount(width, height);
      if (Math.abs(newCount - activeParticleCount) > 10000) {
        buildParticleGeometry();
      } else {
        const { targetW, targetH } = calculateTargetPositions(width, height);
        for (let i = 0; i < activeParticleCount; i++) {
          const p = particlesData[i];
          p.ox = p.nx * targetW + (Math.random() - 0.5) * 0.8;
          p.oy = p.ny * targetH + (Math.random() - 0.5) * 0.8;
        }
      }
    };

    const animate = () => {
      if (!running) {
        animFrameId = null;
        return;
      }
      animFrameId = requestAnimationFrame(animate);
      if (!particleSystem) return;

      const timeSinceHover = Date.now() - lastInteractionTime;
      const positions = particleSystem.geometry.attributes.position.array;
      const mouseSpeed = Math.hypot(mouse.vx, mouse.vy);
      const isMoving = mouseSpeed > 0.1;
      const windDirX = isMoving ? mouse.vx / mouseSpeed : 0;
      const windDirY = isMoving ? mouse.vy / mouseSpeed : 0;
      const viewportMinDim = Math.min(container.clientWidth, container.clientHeight);
      const baseMouseRadius = viewportMinDim * CONFIG.mouseSize;
      const easeFunc = EasingFunctions[CONFIG.retractingEase] || EasingFunctions.linear;

      for (let i = 0; i < activeParticleCount; i++) {
        const p = particlesData[i];
        const dx = p.x - mouse.x;
        const dy = p.y - mouse.y;
        const distSq = dx * dx + dy * dy;
        const maxRadius = baseMouseRadius * p.radiusNoise;
        const maxRadiusSq = maxRadius * maxRadius;

        if (distSq < maxRadiusSq && isMoving) {
          const proximity = Math.exp((-distSq / maxRadiusSq) * 3.2);
          const dustImpulse = proximity * Math.min(mouseSpeed * 0.18, 3.2) * p.sensitivity;
          p.vx += windDirX * dustImpulse;
          p.vy += windDirY * dustImpulse;
          const perpX = -windDirY;
          const perpY = windDirX;
          const randomScatter = (Math.random() - 0.5) * dustImpulse * 1.1;
          p.vx += perpX * randomScatter + (Math.random() - 0.5) * 0.3;
          p.vy += perpY * randomScatter + (Math.random() - 0.2) * 0.4;
        }

        p.x += p.vx;
        p.y += p.vy;
        p.vx *= p.drag;
        p.vy *= p.drag;

        if (timeSinceHover > CONFIG.reassembleDelay) {
          const distX = p.ox - p.x;
          const distY = p.oy - p.y;
          const currentDist = Math.hypot(distX, distY);
          if (currentDist > 0.01) {
            const normDist = Math.min(currentDist / (viewportMinDim * 0.5), 1);
            const step = CONFIG.retractingSpeed * p.springVariance * Math.max(easeFunc(normDist), 0.1);
            p.x += distX * step;
            p.y += distY * step;
          }
        }

        positions[i * 3] = p.x;
        positions[i * 3 + 1] = p.y;
      }

      mouse.vx *= 0.6;
      mouse.vy *= 0.6;
      particleSystem.geometry.attributes.position.needsUpdate = true;
      renderer.render(scene, camera);
      // Once the solid white particle logo is drawing, hide the static pre-load
      // / theme-editor fallback.
      if (!container.hasAttribute('data-particles-active')) {
        container.setAttribute('data-particles-active', '');
      }
    };

    const start = () => {
      if (running) return;
      running = true;
      if (!animFrameId) animate();
    };
    const stop = () => {
      running = false;
    };

    const startWhenVisible = () => {
      if (!('IntersectionObserver' in window)) {
        start();
        return;
      }
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => (entry.isIntersecting ? start() : stop()));
        },
        { threshold: 0.05 }
      );
      io.observe(container);
    };

    // Init renderer + scene.
    const width = container.clientWidth;
    const height = container.clientHeight;
    scene = new THREE.Scene();
    camera = new THREE.OrthographicCamera(-width / 2, width / 2, height / 2, -height / 2, 1, 1000);
    camera.position.z = 500;
    renderer = new THREE.WebGLRenderer({ alpha: true, antialias: true });
    renderer.setSize(width, height);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    container.appendChild(renderer.domElement);

    container.addEventListener('pointermove', (e) => {
      const rect = container.getBoundingClientRect();
      const currentX = e.clientX - rect.left - rect.width / 2;
      const currentY = -(e.clientY - rect.top - rect.height / 2);
      if (mouse.lastX !== null) {
        mouse.vx = (currentX - mouse.lastX) * 0.9;
        mouse.vy = (currentY - mouse.lastY) * 0.9;
      }
      mouse.x = currentX;
      mouse.y = currentY;
      mouse.lastX = currentX;
      mouse.lastY = currentY;
      lastInteractionTime = Date.now();
    });
    container.addEventListener('pointerleave', () => {
      mouse.x = -9999;
      mouse.y = -9999;
      mouse.lastX = null;
      mouse.lastY = null;
      mouse.vx = 0;
      mouse.vy = 0;
    });
    window.addEventListener('resize', onWindowResize);

    sampleSVGPoints();
  }
}

if (!customElements.get('toppik-logo-dust')) {
  customElements.define('toppik-logo-dust', ToppikLogoDust);
}
